<template>
	<v-container>
		<v-form ref="locumBankDetailsForm">
			<v-text-field v-model="accountholder" label="Account holder name" outlined></v-text-field>

			<v-text-field v-model="bankname" label="Bank name" outlined></v-text-field>

			<v-text-field v-model="branchcode" label="Branch code" outlined :rules="[numberOnlyRule]"></v-text-field>

			<v-text-field v-model="accountnumber" label="Account number" outlined :rules="[numberOnlyRule]"></v-text-field>

			<v-radio-group v-model="accounttype" row color="orange">
				<v-radio label="Cheque account" value="cheque" color="primary"></v-radio>
				<v-radio label="Savings account" value="savings" color="primary"></v-radio>
			</v-radio-group>

			<v-text-field v-model="sarsnumber" label="SARS registration number" outlined :rules="[numberOnlyRule]"></v-text-field>

			<v-row align="center" justify="center">
				<v-col align="center" justify="center" :cols="7">
					<DistinctYesNo :initial="hasProvisionalTax" :errors="taxPayerYesNoErrors" @input="OnProvisionalTax">Are you a provisional tax payer?</DistinctYesNo>
				</v-col>
			</v-row>

			<v-row>
				<v-col :cols="12" :lg="6">
					<div v-show="hasProvisionalTax == 'yes'">
						<v-file-input
							:label="labelTax"
							:persistent-hint="true"
							:prepend-icon="''"
							prepend-inner-icon="cloud_upload"
							:dense="true"
							outlined
							chips
							show-size
							:error-messages="taxPayerInputError"
							@change="handleProvisionalTaxFile"
						></v-file-input>
						<span v-if="docExists('provisionalTaxFile')">Provisional tax document already uploaded. Click above to upload a new document.</span>
					</div>
				</v-col>
			</v-row>
		</v-form>
		<v-row v-if="solo">
			<v-btn text @click="$refs.locumVerificationForm.reset()">Clear</v-btn>
			<v-spacer></v-spacer>
			<v-btn class="white--text" color="deep-purple accent-4" depressed @click="SubmitForm()">Update</v-btn>
		</v-row>
	</v-container>
</template>

<script>
import { bus } from '@/main';
import axios from 'axios';

import store from '@/store';
import DistinctYesNo from '@/components/custom/YesNo.vue';

export default {
	components: {
		DistinctYesNo,
	},
	props: {
		solo: {
			type: Boolean,
			default: true,
		},
	},
	data: () => ({
		name: 'locumBankDetailsForm',

		accountholder: 'payment_info' in store.getters.user ? store.getters.user.payment_info.account_holder : null,
		bankname: 'payment_info' in store.getters.user ? store.getters.user.payment_info.bank_name : null,
		branchcode: 'payment_info' in store.getters.user ? store.getters.user.payment_info.branch_code : null,
		accountnumber: 'payment_info' in store.getters.user ? store.getters.user.payment_info.account_number : null,
		accounttype: 'payment_info' in store.getters.user ? store.getters.user.payment_info.account_type : 'cheque',
		sarsnumber: 'payment_info' in store.getters.user ? store.getters.user.payment_info.tax_number : null,
		taxpayer: 'payment_info' in store.getters.user ? store.getters.user.payment_info.tax_payer : null,
		taxPayerYesNoErrors: false,
		taxPayerInputError: [],
		numberOnlyRule: v => {
			if (!v) return true;
			if (/^[0-9]+$/.test(v)) return true;
			return 'only numbers are accepted';
		},

		taxpayerFile: false,
		insuranceFile: false,

		hasProvisionalTax: 'payment_info' in store.getters.user ? (store.getters.user.payment_info.tax_payer ? 'yes' : 'no') : 'none',

		form: false,

		rules: {
			length: len => v => (v || '').length >= len || `Invalid character length, required ${len}`,
			password: v =>
				(v || '').match(/^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*(_|[^\w])).+$/) || 'Password must contain an upper case letter, a numeric character, and a special character',
			required: v => !!v || 'This field is required',
		},
	}),
	computed: {
		labelTax() {
			if ('documents' in store.getters.user && store.getters.user.documents.images.some(img => img == 'provisionalTaxFile')) {
				return 'Upload a new provisional tax payer doc';
			} else {
				return 'Upload provisional tax payer docs';
			}
		},
	},
	mounted() {
		window.scrollTo(0, 0);
		if (this.solo) {
			bus.$on('intent:submit-forms:' + this.name, data => {
				if (this.validate()) {
					bus.$emit('update:spinning', true);
					this.postToBackend(data);
				}
			});
		} else {
			bus.$on('intent:submit-forms', data => {
				if (this.validate()) {
					bus.$emit('update:spinning', true);
					this.postToBackend(data);
				}
			});
		}
	},
	beforeDestroy() {
		bus.$off('intent:submit-forms');
		bus.$off('intent:submit-forms:' + this.name);
	},
	methods: {
		validate() {
			this.taxPayerYesNoErrors = false;
			if (this.hasProvisionalTax != 'yes' && this.hasProvisionalTax != 'no') {
				this.taxPayerYesNoErrors = 'Please select YES or NO';
				window.scrollTo(0, 0);
			}

			return this.$refs.locumBankDetailsForm.validate() && !this.taxPayerYesNoErrors;
		},
		reset() {
			this.$refs.locumBankDetailsForm.reset();
			this.taxPayerYesNoErrors = false;
		},
		resetValidation() {
			this.$refs.locumBankDetailsForm.resetValidation();
			this.taxPayerYesNoErrors = false;
		},
		OnProvisionalTax(a) {
			this.taxPayerYesNoErrors = false;
			this.hasProvisionalTax = a;
			this.taxpayer = a == 'yes';
		},
		handleProvisionalTaxFile(fileObject) {
			this.taxPayerInputError = [];
			const reader = new FileReader();

			reader.onload = e => {
				this.taxpayerFile = e.target.result;
			};
			reader.readAsDataURL(fileObject);
		},
		docExists(docName) {
			return 'documents' in store.getters.user && store.getters.user.documents.images.some(img => img == docName);
		},
		async postToBackend() {
			//post to api backend for this form.

			const token = store.getters.jwtToken;

			if (this.hasProvisionalTax == 'yes') {
				if (this.taxpayerFile) {
					await axios.post(store.getters.getDOCUMENTS + '/images/provisionalTaxFile/' + store.getters.user.id, this.taxpayerFile, { headers: { Authorization: token } });
					if (!('documents' in store.getters.user && store.getters.user.documents.images.some(img => img == 'provisionalTaxFile'))) {
						let save = await axios.put(store.getters.getAPI + '/professionals/documents/images', { doc: 'provisionalTaxFile' }, { headers: { Authorization: token } });
						await store.commit('SET_USER', save.data.data); //refresh the users state. await it completed.
					}
				} else {
					if (!this.docExists('provisionalTaxFile')) {
						this.taxPayerInputError = ['Please provide a provisional tax file'];
						bus.$emit('update:spinning', false);
						window.scrollTo(0, 0);
						return 'Please provide a provisional tax file';
					}
				}
			}
			let body = {
				bank_name: this.bankname,
				account_holder: this.accountholder,
				account_number: this.accountnumber,
				branch_code: this.branchcode,
				account_type: this.accounttype,
				tax_payer: this.taxpayer,
				tax_number: this.sarsnumber,
			};
			await axios
				.put(store.getters.getAPI + '/professionals/bankaccount', body, { headers: { Authorization: token } })
				.then(async response => {
					bus.$emit('form-submitted', { form: this.name, status: response.status });
					if (response.status === 200) {
						store.commit('SET_USER', response.data.data); //refresh the users state.
					}
					bus.$emit('intent:next-step', 'banking-step');
				})
				.catch(err => {
					console.error('failed, error =', err);
					window.scrollTo(0, 0);
					bus.$emit('update:spinning', false);
				})
				.finally(() => {
					bus.$emit('update:spinning', false);
				});
		},
		SubmitForm() {
			const valid = this.validate();

			if (valid) {
				bus.$emit('intent:submit-forms:' + this.name);
			} else {
				window.scrollTo(0, 0);
			}
		},
	},
};
</script>
